import React from 'react'
import "./Goals.css"

export default function Games() {
    return (
        <div className="goals__container">
            <h1 className="skills__heading">2023 Goals</h1>
        </div>
    )
}
